import Model from '@/app/Model'
import { Thumbnail } from '@/models/Thumbnail'

export class Client extends Model {
	static fields () {
		return {
			id: null,
			nickname: null,
			name: null,
			surname: null,
			departmentId: null,
			departmentName: null,
			// department: Department,
			picture: Thumbnail,
			email: null,
			phoneNumber: null,
			city: null,
			country: null,
			address: null,
			margin: null,
			balance: null,
			limit: null,
			credit: null,
			postalCode: null,
			deliveryName: null,
			status: null,
			totalPrice: null,
			totalQuantity: null,
			deliveryPhoneNumber: null,
			departmentClient: null,
			deliveryEmail: null,
			deliveryAddress: null,
			deliveryCity: null,
			deliveryPostalCode: null,
			deliveryCountry: null,
			companyName: null,
			companyCode: null,
			companyVatCode: null,
			companyAddress: null,
			companyCountry: null,
			companyCity: null,
			companyPhoneNumber: null,
			companyEmail: null,
			companyPostalCode: null,
			delayPayment: null,
			delayPaymentDays: null,
			locked: false,
			companyClient: null,
			editable: null
		}
	}

	static hasMany () {
		return {
		}
	}
}

export function createClient (data) {
	// return Object.freeze(new User(data))
	return new Client(data)
}
